import { create } from "zustand";

export const useDocsStore = create((set) => ({
  activeSelection: "",
  setActiveSelection: (id) => set({ activeSelection: id }),
}));
